import { Box } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import RequiredSvg from 'static/images/icons/required-text.svg';

function FormSection({ heading, subheading, required, children, style }) {
  return (
    <React.Fragment>
      <Box
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {heading && (
          <Typography
            variant="h5"
            style={{
              fontFamily: 'Work Sans, sans-serif',
              fontWeight: 600,
              marginTop: '2rem',
            }}
          >
            {heading}
          </Typography>
        )}
        {required && <RequiredSvg style={{ marginTop: '40px' }} />}
      </Box>
      <Box
        style={{
          margin: '1rem 0',
          background: '#FAFAFA',
          borderRadius: '5px',
          padding: '1.5rem',
          border: '1px solid #FAFAFA',
          ...style,
        }}
      >
        {subheading && (
          <div>
            <p style={{ fontWeight: 700, fontSize: '16px' }}>{subheading}</p>
          </div>
        )}
        {children}
      </Box>
    </React.Fragment>
  );
}

export default FormSection;



// WEBPACK FOOTER //
// ./src/views/components/Common/FormSection/FormSection.jsx